import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.sort.js";
import { resolveVariant } from '../../render/utils/resolve-dynamic-variants.mjs';
import { animateTarget } from './visual-element-target.mjs';
function animateVariant(visualElement, variant) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a;
  var resolved = resolveVariant(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
  var _ref = resolved || {},
    _ref$transition = _ref.transition,
    transition = _ref$transition === void 0 ? visualElement.getDefaultTransition() || {} : _ref$transition;
  if (options.transitionOverride) {
    transition = options.transitionOverride;
  }
  /**
   * If we have a variant, create a callback that runs it as an animation.
   * Otherwise, we resolve a Promise immediately for a composable no-op.
   */
  var getAnimation = resolved ? function () {
    return Promise.all(animateTarget(visualElement, resolved, options));
  } : function () {
    return Promise.resolve();
  };
  /**
   * If we have children, create a callback that runs all their animations.
   * Otherwise, we resolve a Promise immediately for a composable no-op.
   */
  var getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? function () {
    var forwardDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var _transition = transition,
      _transition$delayChil = _transition.delayChildren,
      delayChildren = _transition$delayChil === void 0 ? 0 : _transition$delayChil,
      staggerChildren = _transition.staggerChildren,
      staggerDirection = _transition.staggerDirection;
    return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : function () {
    return Promise.resolve();
  };
  /**
   * If the transition explicitly defines a "when" option, we need to resolve either
   * this animation or all children animations before playing the other.
   */
  var _transition2 = transition,
    when = _transition2.when;
  if (when) {
    var _ref2 = when === "beforeChildren" ? [getAnimation, getChildAnimations] : [getChildAnimations, getAnimation],
      _ref3 = _slicedToArray(_ref2, 2),
      first = _ref3[0],
      last = _ref3[1];
    return first().then(function () {
      return last();
    });
  } else {
    return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
  }
}
function animateChildren(visualElement, variant) {
  var delayChildren = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var staggerChildren = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var staggerDirection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var options = arguments.length > 5 ? arguments[5] : undefined;
  var animations = [];
  var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
  var generateStaggerDuration = staggerDirection === 1 ? function () {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return i * staggerChildren;
  } : function () {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return maxStaggerDuration - i * staggerChildren;
  };
  Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach(function (child, i) {
    child.notify("AnimationStart", variant);
    animations.push(animateVariant(child, variant, _objectSpread(_objectSpread({}, options), {}, {
      delay: delayChildren + generateStaggerDuration(i)
    })).then(function () {
      return child.notify("AnimationComplete", variant);
    }));
  });
  return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
  return a.sortNodePosition(b);
}
export { animateVariant, sortByTreeOrder };